import React from 'react';
import { Icon } from './Icon';
import { Colors } from '@/constants/Colors';

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: number;
  onRatingChange?: (rating: number) => void;
  readonly?: boolean;
}

export function StarRating({ rating, maxRating = 5, size = 32, onRatingChange, readonly = false }: StarRatingProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 4, justifyContent: 'center' }}>
      {Array.from({ length: maxRating }).map((_, index) => (
        <button
          key={index}
          onClick={() => !readonly && onRatingChange?.(index + 1)}
          disabled={readonly}
          style={{ cursor: readonly ? 'default' : 'pointer', padding: 0, display: 'flex' }}
        >
          <Icon name={index < rating ? 'star' : 'star-outline'} size={size} color={Colors.primary} />
        </button>
      ))}
    </div>
  );
}
